import { Card } from '@appd/uik';
import React, { ForwardedRef } from 'react';

export const GridLayoutCard = React.forwardRef(
  (
    { style, className, onMouseDown, onMouseUp, onTouchEnd, children, title, key, ...props }: any,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const customPadding = props.gridItem?.padding | 0;
    return (
      <div
        ref={ref}
        key={key}
        style={style}
        className={className}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <Card title={title} style={{ height: '100%', padding: customPadding }}>
          {children.slice(0, children.length - 1)}
        </Card>
        {children.at(-1)}
      </div>
    );
  },
);
